/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'underscore';
import AccountAvatar from 'app/components/SubaccountSelector/AccountAvatar.jsx';

class ChooserHeader extends React.Component {
    render() {
        let headerCopy = this.props.headerCopy || '',
            serviceMessage = null,
            error = this.props.error,
            errorMsg = null;

        if (this.props.serviceMessage !== undefined && this.props.serviceMessage) {
            serviceMessage = (
                <div className="chooser-notice service-message">
                    {this.props.serviceMessage}
                    <br/><br/>
                </div>
            );
        }

        /*
         * The error prop arrives either as a bare string or as a {message, detail}
         * pair built from an API body, and neither field of that pair is
         * guaranteed: RemoteHandler::errorTemplate answers with error/details
         * both null whenever it has no title to report. React throws on an object
         * child, so the pair is always unwrapped here and a generic headline
         * stands in for a missing message — otherwise a failed connect would show
         * nothing at all.
         */
        if (_.isString(error)) {
            errorMsg = error;
        } else if (_.isObject(error)) {
            errorMsg = (
                <div className="chooser-error">
                    <div className="error">
                        <div className="error-headline">
                            {error.message || "Sorry, something went wrong."}
                        </div>
                        {error.detail ? <div className="error-detail">{error.detail}</div> : null}
                    </div>
                </div>
            );
        }

        return (
            <div>
                <AccountAvatar
                    {...this.props}/>
                <div className="chooser-header">
                    {headerCopy}
                    {errorMsg}
                </div>
                {serviceMessage}
            </div>
        );
    }
}

ChooserHeader.displayName = "ChooserHeader";

export default ChooserHeader;
